<template>
  <a-form-item
    v-if="!options.hidden"
    :label="label"
    :class="[{ 'ant-form-item-disabled': disabled }]"
    :required="!disabled && required"
  >
    <widgetItem
      :fieldName="widget.model"
      :placeholder="placeholder"
      :widget="widget"
      :disabled="disabled"
      :isNested="isNested"
      :showLabel="showLabel"
      :rowIndex="rowIndex"
      :parentName="parentName"
      :parentModel="parentModel"
      v-decorator="decorator"
      @noticeParent="handleNoticeParent"
      @change="handleChange"
    >
    </widgetItem>
  </a-form-item>
</template>
<script>
import props from '../../lib/props';
import widgetItem from './compute';

export default {
  name: 'wgCompute',
  mixins: [props],
  components: {
    widgetItem,
  },
};
</script>
